<script>
	// Custom line mark for the Legends of Tasmania experience grid. Drawn to the
	// same geometry as the lucide set used elsewhere (24px box, 1.5 stroke,
	// round caps) so it sits naturally beside them.
	let { class: className = '' } = $props();
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 24 24"
	fill="none"
	stroke="currentColor"
	stroke-width="1.5"
	stroke-linecap="round"
	stroke-linejoin="round"
	class={className}
	aria-hidden="true"
>
	<path d="M12 20 4.5 13a7.5 7.5 0 0 1 15 0Z" />
	<path d="M12 20V5.5" />
	<path d="M12 20 6.7 7.7" />
	<path d="m12 20 5.3-12.3" />
	<path d="M10.6 20.4h2.8" />
</svg>
